import React from 'react';
import { useSearchParams } from 'react-router';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';

export default function FindApplication() {
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get('search');
  return (
    <div className="find-application-wrapper">
      <TextInput
        className="find-application"
        inputAfter={(
          <Icons customIcon className="search" width={16} height={16} icon="search-small" />
        )}
        inputProps={{
          value: search || '',
          onChange: e => setSearchParams({ search: e.target.value || '' }),
        }}
      />
    </div>
  );
}
